import { render, staticRenderFns } from "./DiscoverFilters.vue?vue&type=template&id=51afa99c&"
import script from "./DiscoverFilters.vue?vue&type=script&lang=js&"
export * from "./DiscoverFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports